import Base from "./Base";

class WebSockets extends Base {
  static getWebSocketToken(params) {
    return this.sendRequest("/websockets/get-websocket-token", "GET", params);
  }

  static saveWebSocketClientId(body) {
    return this.sendRequest("/websockets/save-websocket-client-id", "POST", {}, body);
  }
}

export default WebSockets;